import { create } from 'zustand';
import type { User } from '../shared/types/app';

type AppStore = {
  user: User | null;
  lastBookingId: string | null;
  // Actions
  signIn: (user: User) => void;
  setUser: (user: User) => void;
  updateUser: (updates: Partial<User>) => void;
  logout: () => void;
  setLastBookingId: (id: string | null) => void;
};

// Booking-draft persistence lives in useRequestDraftStore.ts (its own persisted store) — see
// that file for why it's kept separate from this one.
export const useAppStore = create<AppStore>((set) => ({
  user: null,
  lastBookingId: null,

  signIn: (user) => set({ user }),
  setUser: (user) => set({ user }),
  updateUser: (updates) =>
    set((s) => ({ user: s.user ? { ...s.user, ...updates } : null })),
  logout: () => set({ user: null, lastBookingId: null }),
  setLastBookingId: (id) => set({ lastBookingId: id }),
}));
